// src/components/ui/MastercardIcon.tsx
import React from 'react';
import bolebabaCardIcon from '../../assets/images/kanzbank-card-icon.svg';
interface MastercardIconProps {
  size?: number;
  className?: string;
}

export const MastercardIcon: React.FC<MastercardIconProps> = ({
  size = 36,
  className = ""
}) => {
  return (
     <div className='flex items-center gap-2'>
      <img src={bolebabaCardIcon} alt="Kanz Bank" width={"30"} height={"20"}/>
      <svg
        width={size}
        height={size * 0.63}
        viewBox="0 0 60 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M23.9522 10H36.0477V28H23.9522V10Z" fill="#FF5F00"/>
        <path d="M25.1294 19C25.1294 15.2998 26.84 11.9826 29.5001 10C27.7895 8.60467 25.6249 7.81847 23.3459 7.81847C17.7889 7.81847 13.2754 12.8333 13.2754 19C13.2754 25.1667 17.7889 30.1815 23.3459 30.1815C25.6249 30.1815 27.7895 29.3954 29.5001 28C26.84 26.0174 25.1294 22.7002 25.1294 19Z" fill="#EB001B"/>
        <path d="M46.7256 19C46.7256 25.1667 42.2121 30.1815 36.6551 30.1815C34.3761 30.1815 32.2115 29.3954 30.5009 28C33.161 26.0174 34.8716 22.7002 34.8716 19C34.8716 15.2998 33.161 11.9826 30.5009 10C32.2115 8.60467 34.3761 7.81847 36.6551 7.81847C42.2121 7.81847 46.7256 12.8333 46.7256 19Z" fill="#F79E1B"/>
      </svg>
    </div>
  );
};

export default MastercardIcon;